import { primaryAddress } from "@productlane/lib/src/email-settings"

import type { EmailInboxSettingsProps } from "../types"
import { DnsStep } from "./dns-step"
import { EnableEmailStep } from "./enable-step"
import { ForwardStep } from "./forward-step"
import { PrimaryEmailStep } from "./primary-email-step"

export function EmailSetupSteps({ workspace }: EmailInboxSettingsProps) {
	const rootDomain = primaryAddress(workspace.emailSettings)
	const isRootVerified =
		!!rootDomain?.isTxtDnsActive && !!rootDomain.isCnameDnsActive

	return (
		<>
			<div className="relative flex gap-4">
				<div className="flex flex-col items-center">
					<div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-white text-sm font-medium text-secondary shadow-card dark:bg-gray-800 dark:shadow-none">
						1
					</div>
					<div
						className={`w-[0.5px] flex-1 bg-gradient-to-b ${
							rootDomain
								? "from-gray-200 to-gray-200 dark:from-gray-700 dark:to-gray-700"
								: "from-gray-200 to-transparent dark:from-gray-700 dark:to-transparent"
						}`}
					/>
				</div>
				<div className="min-w-0 flex-1 pb-8">
					<PrimaryEmailStep workspace={workspace} />
				</div>
			</div>

			{rootDomain && (
				<>
					<div className="relative flex gap-4">
						<div className="flex flex-col items-center">
							<div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-white text-sm font-medium text-secondary shadow-card dark:bg-gray-800 dark:shadow-none">
								2
							</div>
							<div className="w-[0.5px] flex-1 bg-gray-200 dark:bg-gray-700" />
						</div>
						<div className="min-w-0 flex-1 pb-8">
							<ForwardStep workspace={workspace} />
						</div>
					</div>

					{rootDomain.isForwardingSetup && (
						<>
							<div className="relative flex gap-4">
								<div className="flex flex-col items-center">
									<div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-white text-sm font-medium text-secondary shadow-card dark:bg-gray-800 dark:shadow-none">
										3
									</div>
									<div className="w-[0.5px] flex-1 bg-gray-200 dark:bg-gray-700" />
								</div>
								<div className="min-w-0 flex-1 pb-8">
									<DnsStep workspace={workspace} />
								</div>
							</div>

							{isRootVerified && (
								<div className="relative flex gap-4">
									<div className="flex flex-col items-center">
										<div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-white text-sm font-medium text-secondary shadow-card dark:bg-gray-800 dark:shadow-none">
											4
										</div>
									</div>
									<div className="min-w-0 flex-1 pb-8">
										<EnableEmailStep workspace={workspace} />
									</div>
								</div>
							)}
						</>
					)}
				</>
			)}
		</>
	)
}
